// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1xD1x","row":"Node_row__1GIO3","label":"Node_label__2pXvm","footer":"Node_footer__3Jrtf"};